const Images = {
  0: "/1.jpg",
  1: "/2.jpg",
  2: "/3.jpg",
  3: "/4.png",
  4: "/5.png",
  5: "/6.png",
  6: "/7.png",
  7: "/8.png",
};

export { Images };
